var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ExcelJS from 'exceljs';
export const TEMPLATE_COLUMNS = [
    { header: 'Название*', key: 'name', width: 28 },
    { header: 'Госномер', key: 'number', width: 16 },
    { header: 'Страна номера*', key: 'number_country', width: 14 },
    { header: 'Объем бака*', key: 'volume', width: 12 },
    { header: 'Примечание', key: 'comment', width: 24 },
    { header: 'Транспортная группа*', key: 'group_name', width: 22 },
    { header: 'IMEI*', key: 'imei', width: 18 },
    { header: 'Тип терминала*', key: 'device_type_name', width: 14 },
];
const HEADER_TO_KEY = TEMPLATE_COLUMNS.reduce((acc, column) => {
    acc[column.header] = column.key;
    acc[column.header.replace('*', '')] = column.key;
    return acc;
}, {
    Группа: 'group_name',
    'Транспортная группа': 'group_name',
});
const EXAMPLE_ROW = {
    name: 'АТЗ-001',
    number: 'А123АА 77',
    number_country: 'ru',
    volume: '600',
    comment: '',
    group_name: '',
    imei: '352099001761481',
    device_type_name: 'Galileosky',
};
const NUMBER_PATTERNS = {
    ru: [/^([АВЕКМНОРСТУХ]{1}[0-9]{3}[АВЕКМНОРСТУХ]{2}\s?[0-9]{2,3})?$/iu],
    by: [/^[ABCEHKMOPCTYX]{2}\s?[0-9]{4}-?[0-9]{1,2}$/iu, /^[0-9]{4}\s?[ABCEHKMOPCTYX]{2}-?[0-9]{1,2}$/iu],
    az: [/^[0-9]{2}[-]?[A-Z]{2}[-]?[0-9]{3}$/iu],
};
const DEVICE_TYPE_BY_NAME = {
    galileosky: 1,
    wialon: 4,
};
function cellToString(value) {
    if (value === null || value === undefined) {
        return '';
    }
    if (typeof value === 'object') {
        const richValue = value;
        if (richValue.text) {
            return String(richValue.text).trim();
        }
        if (richValue.result !== undefined) {
            return String(richValue.result).trim();
        }
    }
    return String(value).trim();
}
function validateNumber(number, country) {
    if (!number) {
        return null;
    }
    const normalizedCountry = (country || 'ru').toLowerCase();
    const patterns = NUMBER_PATTERNS[normalizedCountry];
    if (!patterns) {
        return 'Недопустимый код страны номера (ru, by, az)';
    }
    const normalizedNumber = number.replace(/[\s]+/g, '');
    if (!patterns.some((pattern) => pattern.test(normalizedNumber))) {
        return `Госномер не соответствует формату для страны ${normalizedCountry.toUpperCase()}`;
    }
    return null;
}
function resolveDeviceType(name) {
    var _a;
    const normalized = cellToString(name).toLowerCase();
    if (!normalized) {
        return null;
    }
    return (_a = DEVICE_TYPE_BY_NAME[normalized]) !== null && _a !== void 0 ? _a : null;
}
function findByName(items, name) {
    const normalized = cellToString(name).toLowerCase();
    if (!normalized) {
        return null;
    }
    return items.find((item) => { var _a; return ((_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === normalized; }) || null;
}
export function validateTransportRow(row, context, duplicateTracker) {
    var _a;
    const errors = [];
    const payload = {
        name: cellToString(row.name),
        number: cellToString(row.number).replace(/[\s]+/g, '') || undefined,
        number_country: cellToString(row.number_country).toLowerCase(),
        volume: cellToString(row.volume),
        comment: cellToString(row.comment) || undefined,
        imei: cellToString(row.imei),
        group_id: undefined,
        device_type: undefined,
        tank: [],
        retransmission_lukoil_on: 0,
        retransmission_rnis_on: 0,
    };
    if (!payload.name) {
        errors.push('Название обязательно');
    }
    else if (payload.name.length < 3) {
        errors.push('Название должно содержать минимум 3 символа');
    }
    if (!payload.volume) {
        errors.push('Объем бака обязателен');
    }
    else if (!/^[0-9]{1,4}$/iu.test(payload.volume)) {
        errors.push('Объем бака должен содержать от 1 до 4 цифр');
    }
    if (!payload.number_country) {
        errors.push('Страна номера обязательна');
    }
    else if (['ru', 'by', 'az'].indexOf(payload.number_country) === -1) {
        errors.push('Страна номера должна быть ru, by или az');
    }
    const numberError = validateNumber(payload.number, payload.number_country);
    if (numberError) {
        errors.push(numberError);
    }
    if (payload.comment && payload.comment.length > 500) {
        errors.push('Примечание не должно превышать 500 символов');
    }
    const groupName = cellToString(row.group_name);
    if (!groupName) {
        errors.push('Транспортная группа обязательна');
    }
    const group = findByName(context.groupItems, row.group_name);
    if (groupName && !group) {
        errors.push(`Транспортная группа «${groupName}» не найдена`);
    }
    else if (group) {
        payload.group_id = group.id;
    }
    const deviceTypeName = cellToString(row.device_type_name);
    if (!deviceTypeName) {
        errors.push('Тип терминала обязателен');
    }
    const deviceType = resolveDeviceType(row.device_type_name);
    if (deviceTypeName && deviceType === null) {
        errors.push('Тип терминала должен быть Galileosky или Wialon');
    }
    else if (deviceType !== null) {
        payload.device_type = deviceType;
    }
    if (!payload.imei) {
        errors.push('IMEI обязателен');
    }
    else if (payload.device_type === 1 && !/^[0-9]{15,16}$/iu.test(payload.imei)) {
        errors.push('IMEI Galileosky должен содержать 15–16 цифр');
    }
    else if (payload.device_type === 4 && !/^[0-9]{1,16}$/iu.test(payload.imei)) {
        errors.push('IMEI Wialon должен содержать от 1 до 16 цифр');
    }
    const checkDuplicate = (field, value, label) => {
        if (!value) {
            return;
        }
        const key = `${field}:${value}`;
        if (duplicateTracker.file.has(key)) {
            errors.push(`${label} «${value}» дублируется в файле (строка ${duplicateTracker.file.get(key)})`);
        }
        else {
            duplicateTracker.file.set(key, row.rowNumber);
        }
        if (duplicateTracker.existing.has(key)) {
            errors.push(`${label} «${value}» уже существует в системе`);
        }
    };
    checkDuplicate('name', payload.name, 'Название');
    checkDuplicate('imei', payload.imei, 'IMEI');
    if (payload.number) {
        checkDuplicate('number', `${payload.number_country || 'ru'}:${payload.number}`, 'Госномер');
    }
    const deviceTypeTitle = ((_a = config.transportDeviceOptions.find((option) => option.type === payload.device_type)) === null || _a === void 0 ? void 0 : _a.title) ||
        deviceTypeName ||
        '—';
    return {
        rowNumber: row.rowNumber,
        preview: {
            name: payload.name,
            number: payload.number || '—',
            volume: payload.volume,
            group_name: (group === null || group === void 0 ? void 0 : group.name) || groupName || '—',
            comment: payload.comment || '—',
            imei: payload.imei || '—',
            device_type_name: deviceTypeTitle,
        },
        payload,
        errors,
        isValid: errors.length === 0,
    };
}
export function validateTransportRows(rows, context, existingItems = []) {
    const duplicateTracker = {
        file: new Map(),
        existing: new Map(),
    };
    existingItems.forEach((item) => {
        if (item.name) {
            duplicateTracker.existing.set(`name:${item.name}`, true);
        }
        if (item.imei) {
            duplicateTracker.existing.set(`imei:${item.imei}`, true);
        }
        if (item.number) {
            duplicateTracker.existing.set(`number:${item.number_country || 'ru'}:${item.number.replace(/[\s]+/g, '')}`, true);
        }
    });
    return rows.map((row) => validateTransportRow(row, context, duplicateTracker));
}
export function parseTransportExcel(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const buffer = yield file.arrayBuffer();
        const workbook = new ExcelJS.Workbook();
        yield workbook.xlsx.load(buffer);
        const worksheet = workbook.getWorksheet('Данные') || workbook.worksheets[0];
        if (!worksheet) {
            throw new Error('В файле не найден лист с данными');
        }
        const headerRow = worksheet.getRow(1);
        const columnIndexByKey = {};
        headerRow.eachCell((cell, colNumber) => {
            const header = cellToString(cell.value);
            const key = HEADER_TO_KEY[header] || HEADER_TO_KEY[header.replace('*', '')];
            if (key) {
                columnIndexByKey[key] = colNumber;
            }
        });
        const requiredHeaders = ['name', 'volume', 'number_country', 'group_name', 'imei', 'device_type_name'];
        const missingHeaders = requiredHeaders.filter((key) => !columnIndexByKey[key]);
        if (missingHeaders.length) {
            throw new Error('Файл не соответствует шаблону. Скачайте актуальный шаблон и заполните его.');
        }
        const rows = [];
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1) {
                return;
            }
            const parsedRow = { rowNumber };
            Object.keys(columnIndexByKey).forEach((key) => {
                const colNumber = columnIndexByKey[key];
                if (colNumber !== undefined) {
                    parsedRow[key] = cellToString(row.getCell(colNumber).value);
                }
            });
            const isEmpty = !parsedRow.name && !parsedRow.volume && !parsedRow.number && !parsedRow.imei;
            if (!isEmpty) {
                rows.push(parsedRow);
            }
        });
        if (!rows.length) {
            throw new Error('В файле нет строк с данными для импорта');
        }
        return rows;
    });
}
export function downloadTransportTemplate(referenceData) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const workbook = new ExcelJS.Workbook();
        const dataSheet = workbook.addWorksheet('Данные');
        const referenceSheet = workbook.addWorksheet('Справочник');
        dataSheet.columns = TEMPLATE_COLUMNS.map((column) => ({
            header: column.header,
            key: column.key,
            width: column.width,
        }));
        dataSheet.addRow(Object.assign(Object.assign({}, EXAMPLE_ROW), { group_name: ((_a = referenceData.groupItems[0]) === null || _a === void 0 ? void 0 : _a.name) || '' }));
        const headerRow = dataSheet.getRow(1);
        headerRow.font = { bold: true };
        headerRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE8F0FE' },
        };
        dataSheet.views = [{ state: 'frozen', ySplit: 1 }];
        referenceSheet.columns = [
            { header: 'Транспортные группы', key: 'group', width: 30 },
            { header: 'Типы терминалов', key: 'device', width: 18 },
            { header: 'Страны номера', key: 'country', width: 16 },
        ];
        const maxRows = Math.max(referenceData.groupItems.length, config.transportDeviceOptions.length, config.transportNumberOptions.length, 1);
        for (let i = 0; i < maxRows; i += 1) {
            referenceSheet.addRow({
                group: ((_b = referenceData.groupItems[i]) === null || _b === void 0 ? void 0 : _b.name) || '',
                device: ((_c = config.transportDeviceOptions[i]) === null || _c === void 0 ? void 0 : _c.title) || '',
                country: config.transportNumberOptions[i]
                    ? `${config.transportNumberOptions[i].code} (${config.transportNumberOptions[i].title})`
                    : '',
            });
        }
        referenceSheet.getRow(1).font = { bold: true };
        const buffer = yield workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `шаблон_транспорт_${new Date().toISOString().slice(0, 10)}.xlsx`;
        link.click();
        setTimeout(() => URL.revokeObjectURL(url), 100);
    });
}
